// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__f5N47","content":"notfound_content__k0X2T","text":"notfound_text__kKPn1"};